import { useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import ChangePasswordForm from "./PasswordChange";
import PersonalData from "./popups/PersonalData";
import CoWorkers from "./popups/CoWorkers";
import Editing from "./popups/Editing";
import OurCompany from "./popups/OurCompany";

import dropdownIcon from "../assets/images/dropdown.png";
import logo from "../assets/images/logo.jpg";
import close from "../assets/svg/free-icon-minimize-sign-6057365 2.svg";
import minimize from "../assets/svg/icon-minimize-sign.svg";
import rollUp from "../assets/svg/icon_roll up.svg";
import home from "../assets/svg/icon-home.svg";

const Clasificator = () => {
  const [isShownPasswordForm, setIsShownPasswordForm] = useState(false);
  const [isShownDataForm, setIsShownDataForm] = useState(false);
  const [isShownCoWorkersForm, setIsShownCoWorkersForm] = useState(false);
  const [isShownCompanyForm, setIsShownCompanyForm] = useState(false);
  const [isShownEditingForm, setIsShownEditingForm] = useState(false);
  const changeIsDataFormOpen = () => {
    setIsShownDataForm(!isShownDataForm);
  };
  const changePassword = () => {
    setIsShownPasswordForm(!isShownPasswordForm);
  };
  const changeIsCoWorkersOpen = () => {
    setIsShownCoWorkersForm(!isShownCoWorkersForm);
  };
  const changeIsOurCompanyOpen = () => {
    setIsShownCompanyForm(!isShownCompanyForm);
  };
  const changeIsEditingForm = () => {
    setIsShownEditingForm(!isShownEditingForm);
  };

  return (
    <section className="clasificator">
      <nav className="navbar">
        {isShownPasswordForm && (
          <ChangePasswordForm changePassword={changePassword} />
        )}
        {isShownPasswordForm && (
          <ChangePasswordForm changePassword={changePassword} />
        )}
        {isShownDataForm && (
          <PersonalData changeIsDataFormOpen={changeIsDataFormOpen} />
        )}
        {isShownCoWorkersForm && (
          <CoWorkers changeIsCoWorkersOpen={changeIsCoWorkersOpen} />
        )}
        {isShownCompanyForm && (
          <OurCompany changeIsOurCompanyOpen={changeIsOurCompanyOpen} />
        )}
        {isShownEditingForm && (
          <Editing changeIsEditingForm={changeIsEditingForm} />
        )}
        <div className="upperNav">
          <div className="upperNav-left">
            <button className="upperNav-btn" onClick={changeIsDataFormOpen}>
              Профиль
            </button>
            <Link to={"/clasificator"} className="upperNav-btn">
              Меню
            </Link>
            <button className="upperNav-btn" onClick={changeIsEditingForm}>
              Общее
            </button>
            <button className="upperNav-btn" onClick={changeIsOurCompanyOpen}>
              Действия
            </button>
            <button className="upperNav-btn" onClick={changeIsCoWorkersOpen}>
              Служебное
            </button>
          </div>
          <div className="upperNav-right">
            <Link to="#" className="upperNav-right__link">
              Наши расчетные счета
            </Link>
            <div className="upperNav-right__menu">
              <button className="upperNav-right__icon">
                <img src={minimize} alt="Minimize" />
              </button>
              <button className="upperNav-right__icon">
                <img src={rollUp} alt="Roll up" />
              </button>
              <button className="upperNav-right__icon">
                <img src={close} alt="Close" />
              </button>
            </div>
          </div>
        </div>

        <div className="middleNav">
          <div className="middleNav-left">
            <div className="middleNav-left1">
              <button className="middleNav-link" onClick={changePassword}>
                <img src={home} alt={"HomeIcon"} className="middleNav-icon" />
              </button>
              <Link to="/general">Копировать как ссылки</Link>
              <Link to="/">Открыть ссылки из буфера обмена</Link>
              <Link to="/">Перезапуск программы</Link>
            </div>
          </div>
          <div className="middleNav-right">
            <p className="middleNav-right__lang">РУС</p>
            <Link to={"/"}>
              <img src={logo} alt="Logo" className="middleNav-right__logo" />
            </Link>
          </div>
        </div>
      </nav>
      <main className="clasificator-list">
        <Link to="/">Сотрудники</Link>
        <Link to="/">Контрагенты</Link>
        <Link to="/">Договоры с клиентами</Link>
        <Link to="/">Технические задания</Link>
        <Link to="/">Работы</Link>
        <Link to="/">Счета</Link>
        <Link to="/">Запрос денежных средств</Link>
        <Link to="/">Финансовые операции</Link>
        <Link to="/">P&L</Link>
        <Link to="/">ДДС</Link>
        <Link to="/">Кредиторская задолженность</Link>
        <Link to="/">Дебиторская задолженность</Link>
        <Link to="/">Управленческий учет</Link>
        <Link to="/">Наша компания</Link>
      </main>
      <footer className="footer">
        <div className="footer-upper">
          <div className="footer-upper__left">
            <p>Занес: Овсяникова К.Ю</p>
            <div className="footer-dropzone">
              <img src={dropdownIcon} alt="Dropdown Icon" />
            </div>
          </div>
          <div className="footer-upper__middle">
            <ol>
              <li className="footer-list__item">Карта Гурова М.С Райффайзен</li>
              <li className="footer-list__item">Карта Пинчук А.А Сбербанк</li>
              <li className="footer-list__item">
                Карта Модернова (Сивцова) Альфа Банк, 4584 4329 6201 2051 (срок
                действия 12/28)
              </li>
            </ol>
          </div>
          <div className="footer-upper__right">
            <div>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
        <div className="footer-lower">
          <div className="footer-lower__texts">
            <p className="footer-lower__text">Драгунов М.В..</p>
            <p className="footer-lower__text">Версия: 10,0,16,9</p>
            <p className="footer-lower__text">0,06+0,46+0,05 сек.</p>
          </div>
          <div className="footer-lower__deviders">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default Clasificator;
